import {addEventActivity} from "../Activities/BrowserDatabaseFunctions";
import {addEventAttendees, updateEventAttendee} from "../Attendees/BrowserDatabaseFunctions";

export const E_updateAttendeePrivilegeResults = async (_incoming) => {
    console.log("E_updateAttendeePrivilegeResults");

    /*
        an Event Attendee had their privilege changed
     */

    try {

        const _result = _incoming.result;

        if (_result === "ok") {





        }
    } catch (e){
        console.log("ERROROROR : "+e);
    }

}

export const E_addNewAttendeeResults = (_incoming) => {
    try {
        if (_incoming?.result !== "ok") {
            console.log("Add result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const newAttendees = _incoming.add_attendee_array;

        if (!eventId || !newAttendees) {
            console.error("Missing event_id or attendees in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            addEventAttendees(eventId, newAttendees).then(success => {
                if (success){
                    //add to master Contact list if necessary

                }
            });
            console.log("new Attendees added successfully");
        } catch (error) {
            console.error("Error adding new Attendees to Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }
}

export const E_updateEventAttendeeFieldsResults = async (_incoming) => {
    console.log("E_updateEventAttendeeFieldsResults");

    /*
        changes to the event attendee data
     */

    try {
        if (_incoming?.result !== "ok") {
            console.log("Update result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const attendeeId = _incoming.attendee_id;
        const updatedImage = _incoming.image;
        const updatedAvatar = _incoming.avatar;
        const updatedFname = _incoming.fname;
        const updatedLname = _incoming.lname;
        const updatedNickname = _incoming.nickname;

        const updatedAddress = _incoming.address;
        const updatedCity = _incoming.city;
        const updatedState = _incoming.state;
        const updatedZip = _incoming.zip;
        const updatedCountry = _incoming.country;

        const updatedEmail = _incoming.email;
        const updatePhonePrefix = _incoming.phone_prefix;
        const updatedPhone = _incoming.phone;

        const updatedDob = _incoming.dob;
        const updatedLanguage = _incoming.language;
        const updatedPreferredAirport = _incoming.preferred_airport;

        const last_mod = _incoming.last_mod;

        if (!eventId || !attendeeId) {
            console.error("Missing event_id or attendeeId in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            updateEventAttendee(eventId, attendeeId, updatedImage, updatedAvatar,
                updatedFname, updatedLname, updatedNickname, updatedAddress, updatedCity, updatedState,
                updatedZip, updatedCountry, updatePhonePrefix, updatedPhone, updatedEmail, updatedDob,
                updatedLanguage, updatedPreferredAirport, last_mod).then(success => {
                if (success){
                    //add to master Contact list if necessary

                }
            });
            console.log("Attendee updated successfully");
        } catch (error) {
            console.error("Error updating Attendee in Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }

}